import { render, staticRenderFns } from "./ListarAlunosTurma.vue?vue&type=template&id=7156bb1a&"
import script from "./ListarAlunosTurma.vue?vue&type=script&lang=js&"
export * from "./ListarAlunosTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports